// extracted by mini-css-extract-plugin
export default {"content":"propertydetail_content__zsvYB"};